<div style="width: 100%;">
    <div id="header" style="width: 100%; height: 40px; background-color: #004466;">
        <p class="global-p dialog_header_font_size">Select Following Data to Export</p>
    </div>
    <form class="global-form cutomer_dialog_form">
        <div style="height: 94px !important; padding-top: 12px;">

            <mat-radio-group style="width: 100%;">
                <mat-radio-button class="example-margin" value="first" (click)="onClick('Summary');" style="padding-left: 10%;"> Summary</mat-radio-button>
                <mat-radio-button class="example-margin" value="second" (click)="onClick('Details');" style="padding-left: 10%;">Summary with details</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="custom_sticky_footer flex-row-spacebetween">
            <div>
                <button class="global-button" type="submit" id="btnn" (click)="cancel()">
                    CANCEL
                </button>
            </div>
            <div>
                <button class="global-button" type="submit" id="btnn" (click)="export()">
                    EXPORT<mat-icon class="icon-style">cloud_upload</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>